import apiClient from './client';
import { DashboardData } from '../types/dashboard';

export const fetchDashboardData = async (): Promise<DashboardData> => {
  const response = await apiClient.get<DashboardData>('/api/dashboard');
  return response.data;
}; 